import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  product_id: yup.string().required("product is required"),
  variant_id: yup.string().optional(),
  store_id: yup.string().required("store is required"),
  quantity: yup
    .number()
    .positive()
    .typeError("Quantity must be a number")
    .required("Quantity is required"),
  reason: yup.string().required("reason is required"),
  expiry_date: yup.string().nullable().optional(),
});

export const useDeleteStockFormValidation = (formData) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: formData,
  });
};
